import { useTranslation } from 'next-i18next';

import { Box, Button, Text } from '@chakra-ui/react';

import { ScrollableWrapper } from '@nocowanie/common-ui/components/molecules/scrollable-wrapper';
import { IKeyValue } from '@nocowanie/common-ui/models';
import { IconsLinear } from '@nocowanie/icons/linear';

import { ReviewsSortingProps } from '@app/components/molecules/reviews-sorting/';
import { ReviewSortEnum } from '@app/enums';

export const ReviewsSorting = ({ currentSort, onSortChange, ...props }: ReviewsSortingProps) => {
    const { t } = useTranslation('accommodation', {
        keyPrefix: 'reviews.sorting',
    });

    const sortOptions: Array<IKeyValue<ReviewSortEnum, string>> = [
        {
            key: ReviewSortEnum.MOST_HELPFUL,
            label: t('mostHelpful'),
        },
        {
            key: ReviewSortEnum.NEWEST,
            label: t('newest'),
        },
        {
            key: ReviewSortEnum.HIGHEST_RATING,
            label: t('highestRating'),
        },
        {
            key: ReviewSortEnum.LOWEST_RATING,
            label: t('lowestRating'),
        },
    ];

    const scrollableStyles = {
        maxW: { base: '100vw', md: '100%' },
        gridAutoColumns: { base: 'max-content', md: '1fr' },
        gap: 2,
        ml: 0,
        pt: 0,
        px: 6,
    };

    return (
        <Box {...props}>
            <ScrollableWrapper scrollableContainerProps={scrollableStyles}>
                {sortOptions.map(option => {
                    const isSelected = currentSort === option.key;
                    return (
                        <Button
                            key={option.key}
                            onClick={() => onSortChange(option.key)}
                            variant={'sorting'}
                            size="sm"
                            color={isSelected ? 'secondary.600' : 'gray.500'}
                            bg={isSelected ? 'secondary.50' : 'gray.100'}
                            pl={isSelected ? 2 : 3.5}
                            data-testid={'review-sorting-button'}
                            data-selected={isSelected}
                        >
                            {isSelected ? <IconsLinear.Tick scale={1.2} /> : null}
                            <Text as={'span'} ml={1}>
                                {option.label}
                            </Text>
                        </Button>
                    );
                })}
            </ScrollableWrapper>
        </Box>
    );
};
